import React, { useContext } from 'react'
import { CollapsibleContext } from 'client/fragments/listerFragment/components/Filters/Collapsible/Collapsible'
import { FaChevronDown } from 'client/common/icons'
import classNames from 'classnames'

export const CollapsibleHeader = props => {
  const { children, htmlFor } = props
  const { isCollapsed, setIsCollapsed } = useContext(CollapsibleContext)
  return (
    <button
      className='mxd-mcollapse-header'
      onClick={() => setIsCollapsed(c => !c)}
      aria-expanded={!isCollapsed}
      aria-controls={htmlFor}
    >
      <h2 className='flex gap-half'>
        {children}
        <FaChevronDown
          className={classNames('mxd-mcollapse-header-icon', {
            'mxd-mcollapse-header-icon--expnd': !isCollapsed
          })}
          fontSize='0.7em'
        />
      </h2>
    </button>
  )
}
